import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Props from '../../../../shared/types/props/focus';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const LanguageText = styled.div<Props>`
  color: ${Colors['light']};
  cursor: pointer;
  font-family: ${(props) => Fonts[props.focused ? 'regular' : 'thin']};
  font-size: ${35 * Screen.widthRatio}px;
  height: ${45 * Screen.widthRatio}px;
  margin-bottom: ${17 * Screen.widthRatio}px;
  transform: ${(props) => `scale(${props.focused ? '1.1' : '1'})`};
  &:hover {
    font-family: ${Fonts['regular']};
    transform: ${'scale(1.1)'};
  }
`;

export default withAnimation(LanguageText);
